import {
  SET_SHOW_PROMPT,
  ADD_APPLICANT_REQUEST,
  ADD_APPLICANT_SUCCESS,
  ADD_APPLICANT_FAILURE,
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  UPLOAD_APPLICANT_DOCUMENTS,
  UPLOAD_APPLICANT_DOCUMENTS_SUCCESS,
  UPLOAD_APPLICANT_DOCUMENTS_FAILURE,
  DELETE_APPLICANT_DOCUMENTS,
  DELETE_APPLICANT_DOCUMENTS_SUCCESS,
  DELETE_APPLICANT_DOCUMENTS_FAILURE,
  FETCH_APPLICANTS_REQUEST,
  FETCH_APPLICANTS_SUCCESS,
  FETCH_APPLICANTS_FAILURE,
  CHECK_SCHEDULE_REQUEST,
  CHECK_SCHEDULE_SUCCESS,
  CHECK_SCHEDULE_FAILURE,
  FETCH_APPLICANT_REQUEST,
  FETCH_APPLICANT_SUCCESS,
  FETCH_APPLICANT_FAILURE,
  UPDATE_APPLICANT_REQUEST,
  UPDATE_APPLICANT_SUCCESS,
  UPDATE_APPLICANT_FAILURE,
  RESET_IS_UPDATE_SUCCESSFUL,
  SET_FAILED_DEFAULT_KEY,
  SET_RESUME_FILENAME,
  RESET_APPLICANTS_STATE,
  RESET_APPLICANT_STATE,
  CLEAR_APPLICANT_VALUES,
  SEARCH_APPLICANT_REQUEST,
  FETCH_APPLICANTS_LIST_REQUEST,
  FETCH_APPLICANTS_AFTER_A_YEAR_COUNT,
  FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_SUCCESS,
  FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_FAILURE,
  FETCH_TOTAL_APPLICANTS_REQUEST,
  FETCH_TOTAL_APPLICANTS_SUCCESS,
  FETCH_TOTAL_APPLICANTS_FAILURE,
  CLEAR_TOTAL_APPLICANTS,
  UPDATE_TOTAL_NEW_APPLICANTS,
  RESET_ISOVERLAP,
} from "./actionTypes";
import { initiateRequest } from "../request/action";

import {
  ApplicantDocument,
  ApplicantType,
  FirebaseApplicant,
  NewApplicantList,
  TotalApplicants,
} from "../../core/entities/applicant";

import { Query } from '../../core/entities/query';

export const setShowPrompt = (value: boolean): object => ({
  type: SET_SHOW_PROMPT,
  payload: value
});

export const addApplicantRequest = (applicant: ApplicantType) => ({
  type: ADD_APPLICANT_REQUEST,
  payload: { applicant }
});

export const addApplicantSuccess = () => ({
  type: ADD_APPLICANT_SUCCESS
});

export const addApplicantFailure = (error: string) => ({
  type: ADD_APPLICANT_FAILURE,
  payload: { error }
});

export const checkScheduleRequest = (
  id: string,
  dateAndTime: string,
  data: Partial<FirebaseApplicant>
) =>
  initiateRequest({
    type: CHECK_SCHEDULE_REQUEST,
    payload: { id, dateAndTime, data },
  });

export const checkScheduleSuccess = (isOverlap: boolean) => ({
  type: CHECK_SCHEDULE_SUCCESS,
  payload: { isOverlap },
});

export const resetIsOverlap = () => ({
  type: RESET_ISOVERLAP,
});

export const checkScheduleFailure = (error: string) => ({
  type: CHECK_SCHEDULE_FAILURE,
  payload: { error },
});

export const uploadImage = (file: Blob, fileName: string) => ({
  type: UPLOAD_IMAGE,
  payload: { file, fileName }
});

export const uploadImageSuccess = (imageUri: string | undefined) => ({
  type: UPLOAD_IMAGE_SUCCESS,
  payload: { imageUri }
});

export const uploadImageFailure = (error: string) => ({
  type: UPLOAD_IMAGE_FAILURE,
  payload: { error }
});

export const uploadApplicantDocuments = (id: string, file: File | Blob , fileName: string) => ({
  type: UPLOAD_APPLICANT_DOCUMENTS,
  payload: { id, file, fileName }
});

export const uploadApplicantDocumentsSuccess = (document: { name: string, src: string, } | undefined) => ({
  type: UPLOAD_APPLICANT_DOCUMENTS_SUCCESS,
  payload: { document }
});

export const uploadApplicantDocumentsFailure = (error: string) => ({
  type: UPLOAD_APPLICANT_DOCUMENTS_FAILURE,
  payload: { error }
});

export const deleteApplicantDocuments = (id: string, document: ApplicantDocument) => ({
  type: DELETE_APPLICANT_DOCUMENTS,
  payload: { id, document }
});

export const deleteApplicantDocumentsSuccess = (document: ApplicantDocument) => ({
  type: DELETE_APPLICANT_DOCUMENTS_SUCCESS,
  payload: { document },
});

export const deleteApplicantDocumentsFailure = (error: string) => ({
  type: DELETE_APPLICANT_DOCUMENTS_FAILURE,
  payload: { error }
});

export const fetchApplicantsRequest = (
  source: string,
  limit?: number,
  where?: [
    string,
    "<" | "<=" | "==" | ">=" | ">" | "in",
    string | number | boolean | Array<any> | Date
  ][]
) =>
  initiateRequest({
    type: FETCH_APPLICANTS_REQUEST,
    payload: { source, limit, where }
  });

export const fetchApplicantsSuccess = (
  applicants: NewApplicantList[] | FirebaseApplicant[]
) => ({
  type: FETCH_APPLICANTS_SUCCESS,
  payload: { applicants }
});

export const fetchApplicantsFailure = (error: string) => ({
  type: FETCH_APPLICANTS_FAILURE,
  payload: { error }
});

export const fetchApplicantRequest = (id: string) => ({
  type: FETCH_APPLICANT_REQUEST,
  payload: { id }
});

export const fetchApplicantSuccess = (applicant: any) => ({
  type: FETCH_APPLICANT_SUCCESS,
  payload: { applicant }
});

export const fetchApplicantFailure = (error: string) => ({
  type: FETCH_APPLICANT_FAILURE,
  payload: { error }
});

export const updateApplicantRequest = (
  id: string,
  data: Partial<FirebaseApplicant>
) =>
  initiateRequest({
    type: UPDATE_APPLICANT_REQUEST,
    payload: { id, data }
  });

export const updateApplicantSuccess = () => ({
  type: UPDATE_APPLICANT_SUCCESS
});

export const updateApplicantFailure = (error: string) => ({
  type: UPDATE_APPLICANT_FAILURE,
  payload: { error }
});

export const resetIsUpdateSuccessful = () => ({
  type: RESET_IS_UPDATE_SUCCESSFUL
});

export const setFailedActiveKeyRequest = (key: string) => ({
  type: SET_FAILED_DEFAULT_KEY,
  payload: { key }
});

export const setResumeFileName = (filename: string) => ({
  type: SET_RESUME_FILENAME,
  payload: { filename }
});

export const resetApplicantsState = () => ({
  type: RESET_APPLICANTS_STATE
});

export const resetApplicantState = () => ({
  type: RESET_APPLICANT_STATE
});

export const clearApplicantValues = () => ({
  type: CLEAR_APPLICANT_VALUES
});

export const searchApplicantRequest = (
  limit?: number,
  where?: [
    string,
    "<" | "<=" | "==" | ">=" | ">" | "array-contains",
    string | number | boolean
  ][]
) =>
  initiateRequest({
    type: SEARCH_APPLICANT_REQUEST,
    payload: { limit, where }
  });

export const fetchApplicantsListRequest = (query: Query) => 
  initiateRequest({
    type: FETCH_APPLICANTS_LIST_REQUEST,
    payload: { query },
  });


export const fetchTotalApplicantsRequest = () => ({
  type: FETCH_TOTAL_APPLICANTS_REQUEST
});

export const fetchTotalApplicantsSuccess = (data: TotalApplicants) => ({
  type: FETCH_TOTAL_APPLICANTS_SUCCESS,
  payload: { data },
});

export const fetchTotalApplicantsFailure = (error: string) => ({
  type: FETCH_TOTAL_APPLICANTS_FAILURE,
  payload: { error }
});

export const clearTotalApplicants = () => ({
  type: CLEAR_TOTAL_APPLICANTS
});

export const updateTotalNewApplicants = (currentPhase: string, prevPhase:string, currentStatus: string) => 
  initiateRequest({
    type: UPDATE_TOTAL_NEW_APPLICANTS,
    payload: { currentPhase, prevPhase, currentStatus },
  });

export const fetchApplicantsAfterAYearCount = (query: Query, status: string) => ({
  type: FETCH_APPLICANTS_AFTER_A_YEAR_COUNT,
  payload: { query, status },
});

export const fetchApplicantsAfterAYearCountSuccess = (total: number, status: string) => ({
  type: FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_SUCCESS,
  payload: { total, status }
});

export const fetchApplicantsAfterAYearCountFailure = (error: string) => ({
  type: FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_FAILURE,
  payload: { error }
});
